import React from 'react';

const NeonBorder = ({ children, className = "" }) => {
  return (
    <div className={`neon-border-container relative ${className}`}>
      {children}
    </div>
  );
};

export default NeonBorder;